import React from 'react'
import gql from 'graphql-tag'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'

interface Props {
  product: {
    state: string
  }
}

const VirtualTourProduct = ({product}: Props) => {
  if (product.state === 'delivered') {
    return (
      <DeliveredUrl product={product} />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

VirtualTourProduct.fragment = gql`
  fragment VirtualTourProduct on VirtualTourProduct {
    assets {
      edges {
        node {
          id
          state
          ...on UrlAsset {url}
        }
      }
    }
  }
`

export default VirtualTourProduct
